import { type Command } from '@telespot/core';

/**
 * Details for {@link RemoveMemberships}
 *
 * @group Workspaces
 * @category Payloads
 */
export interface RemoveMembershipsDetails {
  /**
   * Identifiers of the memberships to remove.
   */
  membershipIds: string[];

  /**
   * The batch size for the removal.
   * Indicates the number of memberships to remove in parallel.
   */
  batchSize: number;
}

/**
 * Errors for {@link RemoveMemberships}
 *
 * @group Workspaces
 * @category Errors
 */
export type RemoveMembershipsError = { type: 'UNKNOWN'; message: string };

/**
 * Command registration token for {@link RemoveMemberships}
 *
 * @group Workspaces
 * @category Tokens
 */
export const REMOVE_MEMBERSHIPS = 'workspaces:removeMemberships';

/**
 * Removes an existing user as a member of a workspace or multiple workspaces.
 *
 * @group Workspaces
 * @category Commands
 */
export class RemoveMemberships implements Command<typeof REMOVE_MEMBERSHIPS, RemoveMembershipsDetails> {
  public readonly name = REMOVE_MEMBERSHIPS;
  constructor(public readonly details: Readonly<RemoveMembershipsDetails>) {}
}
